export const HEADER_MOBILE_INDEX = '1005';
export const HAMBURGER_MENU_INDEX = '1004';
export const MENU_DESKTOP_INDEX = '1005';
export const LIGHTBOX = '1002';
export const BUYING = '1004';
